import { FC } from 'react';
import { useNavigate } from 'react-router';
import { useDispatch, useSelector } from 'react-redux';
import useWindowSize from 'Hooks/useWindowSize';
import { useFeatureFlag } from 'Hooks/useFeatureFlag';
import { IUserInforResponse } from 'Data/interfaces/Auth/IUserInfoResponse';
import { IStorePlanResponse } from 'Data/interfaces/Store/IStorePlanResponse';
import { RevenuesActions } from 'Store/Revenues/Revenues.actions';
import { IGlobalReducerState } from 'Store/Base/interface/IGlobalReducerState';
import { getCurrentTenant, getTenants } from 'Store/Tenant/Tenant.selector';
import PlanContainer from 'Components/UI/Containers/PlanContainer/PlanContainer';
import Button from 'Components/UI/Button';
import PlanInfo from '../PlanInfo';
import { Mixpanel } from 'Utils/MixPanel';
import { numberToMoney } from 'Utils/Money';
import { DescriptionBoxPlan, Footer, Main, Separator, Wrapper } from './styles';

import logoMaleta from 'Static/images/logo-maleta-collapse.png';
import tagPopular from 'Static/images/tag-popular.png';

interface IBoxPlanChange {
  plan: IStorePlanResponse;
  currentPlanId?: number;
  currentPlanOrder?: number;
  userInfo?: IUserInforResponse;
}

const BoxPlanChange: FC<IBoxPlanChange> = ({
  plan,
  currentPlanId,
  currentPlanOrder,
  userInfo,
}) => {
  const whatsappContactLinkFlag = useFeatureFlag('whatsapp-contact-link');
  const whatsappContactLink = (whatsappContactLinkFlag.enabled && typeof whatsappContactLinkFlag.value === 'string')
    ? whatsappContactLinkFlag.value
    : (process.env.REACT_APP_CONTACT_LINK || '');

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { height } = useWindowSize();

  const tenants = useSelector(getTenants);
  const currentTenant = useSelector(getCurrentTenant);
  const planIsFree = useSelector((state: IGlobalReducerState) => state.auth.planFree);
  const advantages = plan?.Info.split('\n');

  const upgradePlan = (plano: IStorePlanResponse | undefined) => {
    if (plano) {
      dispatch(RevenuesActions.getPlanForChange({
        ...plan
      }));
      navigate('/faturamento/planos/dadosfaturamento');
    }
  };

  return (
    <Wrapper>
      <PlanContainer
        width="259px"
        heigth={`${height - 160}px`}
        minMax
        style={{ margin: '25px 0 14px 15px', padding: '0' }}
      >
        <DescriptionBoxPlan>
          {plan.IsDefault ? (
            <div className="tag-popularity">
              <img src={tagPopular} alt="Tag Popularidade" />
            </div>
          ) : null}
          <div className="logo-description">
            <img src={logoMaleta} alt="logo da maleta" />
            <span>{plan.Name}</span>
          </div>
        </DescriptionBoxPlan>

        <Separator />

        <Main>
          <span>{plan.Description}</span>

          <Separator marginbottom={12} />

          <div>
            {advantages?.map((advn: string, index: number) => (
              <PlanInfo key={index} advantage={advn} />
            ))}
          </div>
        </Main>

        <Separator margintop={12} />

        <Footer>
          <div className="price-box-plan">
            <div>
              {plan.Price === 0 ? (
                plan.isCustom === 1 ?
                  <>
                    <div className="price-custom">
                      {'Preço Customizado. Entre em contato para mais informações'}
                    </div>
                  </>
                  : <span className="price-text">Grátis</span>
              ) : (
                <div className="price-box">
                  <span className="price-text">{numberToMoney(plan.Price, 'real')}</span>
                  <span className="price-text-last">/mês</span>
                </div>
              )}
            </div>
          </div>


          <div className="button-box-plan">
            {((currentPlanId && plan.StorePlansId) && (currentPlanId === plan.StorePlansId)) ||
              (planIsFree && (plan.Price === 0 || !plan.Price) && plan.isCustom === 0) ? (
              <Button
                className="button-plan"
                disabled
              >
                Plano Atual
              </Button>
            ) : ((currentPlanOrder && plan.Order) && (plan.Order < currentPlanOrder)) ? (
              <Button
                className="button-plan"
                onClick={() => upgradePlan({
                  ...plan
                })}
              >
                Downgrade
              </Button>
            ) : (plan.isCustom === 1) ? (
              <Button
                className="button-custom-plan"
                type="text"
              >
                <a
                  href={whatsappContactLink}
                  target="_blank"
                  rel="noopener noreferrer"
                  onClick={() => Mixpanel.track({
                    name: 'ENTERPRISE_CALL_CONTACT',
                    props: {},
                    userInfo,
                    currentListTenant: currentTenant,
                    tenantIds: tenants && tenants.length > 0
                      ? tenants?.map((tenant) => tenant?.TenantId).filter((tenantId) => tenantId !== undefined) as number[]
                      : undefined,
                  })
                  }
                >
                  Entrar em contato
                </a>
              </Button>
            ) : (
              <Button
                className="button-plan"
                type="primary"
                onClick={() => upgradePlan({
                  ...plan
                })}
              >
                Selecionar Plano
              </Button>
            )}
          </div>
        </Footer>
      </PlanContainer>
    </Wrapper>
  )
}

export default BoxPlanChange;
